import { BetaSchemaForm } from "@ant-design/pro-components";
import { transformRawToAntd } from "./util";
import { useTranslation } from "react-i18next";
import { createStyles } from "antd-style";
import { forwardRef } from "react";
import { useWarnAboutChange } from "@refinedev/core";

const LAYOUT_TYPE_HORIZONTAL = 'horizontal';

const useStyles = createStyles(({ token, css }) => ({
  'form-set': css`
    & > div:first-child > div:first-child > label {
      font-weight: bold;
    }
  `,
  'form-array': css`
    & > div:first-child > div:first-child {
      max-width: 100%;
    }
  `,
}));

export const FormContainer = forwardRef(({
  initValue: rawValue,
  schema: rawSchema,
  onFinishCallback,
  formRef,
  layout="horizontal",
  formItemLayout,
  onValuesChange: onValuesChangeProps,
  ...restFormProps
}) => {
  const { styles, } = useStyles();
  const { setWarnWhen } = useWarnAboutChange();

  const { t } = useTranslation();

  const { schema:antdColumns, value: initValue } = transformRawToAntd(rawSchema, rawValue, { t, styles, });

  const onFinish = async (values) => {
    /* console.log('Received values:', values);
    const result = transformAntdValueToRawValue(values, rawSchema);
    */
    setWarnWhen(false);
    if (onFinishCallback) {
      onFinishCallback(values);
    }
  }

  const onValuesChange = (changedValues, allValues) => {
    setWarnWhen(true);
    if (onValuesChangeProps) {
      onValuesChangeProps(changedValues, allValues);
    }
  };

  if(!formItemLayout) {
    formItemLayout =
      layout === LAYOUT_TYPE_HORIZONTAL
        ? {
            labelCol: { span: 10 },
            wrapperCol: { span: 14 },
          }
        : null;
  }

  return (
    <BetaSchemaForm
      formRef={formRef}
      initialValues={initValue}
      layoutType='Form'
      columns={antdColumns}
      onFinish={onFinish}
      grid={true}
      layout={layout}
      submitter={{
        render: () => null
      }}
      onValuesChange={onValuesChange}
      {...formItemLayout}
      {...restFormProps}
    />
  );
});
